import { Component, inject, signal, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService, _ } from '@ngx-translate/core';
import { ROLES } from 'app/core/constants/role.constants';
import { AppButtonsComponent } from "@shared/ui/app-buttons/app-buttons";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { BUTTON_CLASS_TYPES } from 'app/core/constants/app-button.constants';
import { AuthService } from '@shared/services/auth.service';
import { ROUTES } from '@shared/constants/routes';

@Component({
  selector: 'app-signup',
  imports: [TranslatePipe, AppButtonsComponent, ReactiveFormsModule, InputTextModule, ToastModule, MessageModule],
  templateUrl: './signup.html',
  styleUrl: './signup.scss'
})
export class Signup {
  protected readonly entity = signal('');
  protected ROLES = ROLES;
  protected BUTTON_CLASS_TYPES = BUTTON_CLASS_TYPES;

  private cd = inject(ChangeDetectorRef);

  points: Array<string> = [];
  loginForm: FormGroup;
  formSubmitted = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authService: AuthService,
    private translateService: TranslateService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      rememberMe: [false]
    });
  }

  ngOnInit() {
    // Determina il tipo di entità dal path
    const path = this.router.url.split('?')[0].split('#')[0];
    const entityType = path.includes(`/${ROLES.CANDIDATE}`)
      ? ROLES.CANDIDATE
      : ROLES.EMPLOYER;

    this.entity.set(entityType);

    this.translateService.get(_(`signup.${this.entity()}.points`)).subscribe((res: string[]) => {
      // Defer assignment to the next event loop tick
        this.points = res;
    });
  }

  onSubmit() {
    this.formSubmitted = true;
    if (this.loginForm.valid) {
      this.login()
    }
  }

  register() {
    this.router.navigate([ROUTES.REGISTRATION], { relativeTo: this.route });
  }

  login() {
    this.formSubmitted = true;
    if (!this.loginForm.valid) return;

    const { email, password, rememberMe } = this.loginForm.value;

    this.authService.login(email, password).subscribe({
      next: (data: any) => {
        const user = data.data;
        this.authService.setUser(user);
        // Controllo per SSR
        if (typeof window !== 'undefined') {
          if (rememberMe) {
            localStorage.setItem('user', JSON.stringify(user));
          } else {
            sessionStorage.setItem('user', JSON.stringify(user));
          }
        }
        this.router.navigate([this.entity() === ROLES.EMPLOYER ? ROUTES.EMPLOYER_LOGGED_HOME : ROUTES.CANDIDATE_LOGGED_HOME]);
      },
      error: (error) => console.error('Error on login', error),
      complete: () => {
        this.loginForm.reset();
        this.formSubmitted = false;
      }
    });
  }

  isInvalid(controlName: string) {
    const control = this.loginForm.get(controlName);
    return control?.invalid && (control.touched || this.formSubmitted);
  }
}
